import { render, staticRenderFns } from "./grid-column.vue?vue&type=template&id=52c5efba"
import script from "./grid-column.vue?vue&type=script&lang=ts"
export * from "./grid-column.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports